<template>
  <el-row>
    <el-col>
      <el-upload
        class="avatar-uploader"
        :action="getUploadUrl()"
        :show-file-list="false"
        :on-success="handleSuccess"
        :with-credentials="true"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data() {
    return {
      imageUrl: null,
    };
  },
  methods: {
    getUploadUrl: function () {
      return "http://psicologia.ip.usp.br:4100/uploads/images";
    },
    handleSuccess(response) {
      this.imageUrl = `http://psicologia.ip.usp.br:4100${response}`;
      this.emitter.emit("image", this.imageUrl);
    },
    removeUploaderImage() {
      this.imageUrl = null;
      this.emitter.emit("image", this.imageUrl);
    },
  },

  mounted() {
    if (!this.type) {
      this.type = "doc";
    }

    this.emitter.on("image", (imageUrl) => {
      this.imageUrl = imageUrl;
    });

    this.emitter.on("removeUploaderImage", () => {
      this.removeUploaderImage();
    });
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
